module.exports = __webpack_public_path__ + "static/wellburrito-83374b14f3994c2440bfb377fad8c435.webp";